import { Select } from "antd";
import { SelectProps } from "antd/lib/select";
import React from "react";
import { MOption } from "../module/private/shared/shared.model";

export interface CustomSelectProps<T extends MOption>
  extends Omit<SelectProps<T>, "options" | "onChange" | "children"> {
  options: T[];
  onChange?: (value?: T) => void;
}

export default function CustomSelect<T extends MOption>(
  props: CustomSelectProps<T>
) {
  return (
    <Select
      {...props}
      options={props.options.map((x) => {
        return {
          key: x.value,
          value: x.value,
          label: x.label,
        };
      })}
      onChange={(value) => {
        if (props.onChange) {
          props.onChange(
            value
              ? props.options.find((x) => x.value === value.toString())
              : undefined
          );
        }
      }}
    ></Select>
  );
}
